import styled from 'styled-components'

export const Link = styled.a.withConfig({
  shouldForwardProp: (prop) => !['color'].includes(prop)
})``
